var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.487,
    height: 21,
    viewBox: "0 0 24.487 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3064",
    "data-name": "Group 3064",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5597",
    "data-name": "Path 5597",
    d: "M1.472,40.623a1.75,1.75,0,0,1,.3-.022H19.05l-.377-.175a3.5,3.5,0,0,1-.99-.7L12.839,34.88a1.813,1.813,0,0,1-.254-2.321,1.752,1.752,0,0,1,2.628-.228l8.76,8.76a1.752,1.752,0,0,1,0,2.478h0l-8.76,8.76a1.752,1.752,0,0,1-2.628-.175,1.813,1.813,0,0,1,.254-2.321l4.836-4.853a3.5,3.5,0,0,1,.876-.639l.526-.237H1.871A1.813,1.813,0,0,1,.023,42.633,1.752,1.752,0,0,1,1.472,40.623Z",
    transform: "translate(0 -31.842)",
    fill: "#fbb516"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.fc32f77e40d9c81eefe025b1ca95c68d.svg";
export { ForwardRef as ReactComponent };